import { useNavigate } from 'react-router-dom'
import { useProductStore } from '../store/productStore'
import ProductForm from '../features/backoffice/ProductForm'
import { ArrowRight } from 'lucide-react'
import { useEffect } from 'react'

export default function AddProductPage() {
  const { addProduct } = useProductStore()
  const navigate = useNavigate()

  useEffect(() => { window.scrollTo(0, 0) }, [])

  // Keyboard shortcuts
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.preventDefault(); navigate('/admin') }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [navigate])

  return (
    <div dir="rtl" className="min-h-screen bg-cream">
      <div className="fixed inset-0 z-0 pointer-events-none" style={{
        background: `
          radial-gradient(ellipse 70% 50% at 95% 5%, rgba(82,183,136,0.10) 0%, transparent 60%),
          radial-gradient(ellipse 50% 40% at 5% 90%, rgba(244,132,95,0.08) 0%, transparent 55%)
        `
      }} />
      <main className="relative z-10 max-w-[680px] mx-auto px-6 pt-8 pb-16">
        <button
          onClick={() => navigate('/admin')}
          className="flex items-center gap-1.5 bg-white border-none cursor-pointer px-4 py-2 rounded-[10px] text-sm font-medium text-green-primary shadow-[0_2px_8px_rgba(44,24,16,0.07)] mb-6 transition-shadow hover:shadow-[0_4px_16px_rgba(44,24,16,0.12)]"
        >
          <ArrowRight className="h-4 w-4" />
          חזרה לניהול
        </button>
        <h1 className="font-serif text-[28px] font-bold text-text-primary tracking-tight mb-6">
          הוספת מוצר
        </h1>
        <ProductForm
          submitLabel="הוסף מוצר"
          onCancel={() => navigate('/admin')}
          onSubmit={async (data) => {
            const { images, ...fields } = data as typeof data & { images: string[]; media: any[] }
            await addProduct({
              ...fields,
              images: images ?? [],
            })
            navigate('/admin')
          }}
        />
      </main>
    </div>
  )
}
